
// export const CORE_API_ENDPOINT = `http://localhost:2701`
export const CORE_API_ENDPOINT = `/api`
// export const CORE_API_ENDPOINT = `https://dtacuat-back.rmbainisys.com/api`
// export const PREFIX = `/backend`
export const PREFIX = ''


// WEBPACK FOOTER //
// ./src/lib/api.js